const Numeric = require("app/components/fields/Numeric");

class CVR extends Numeric {

}

module.exports = CVR;
